<template>
    <div class="p-3">
        <h3>RL 3.15 Kegiatan Pelayanan Kesehatan Jiwa</h3>
        <hr>
        <DataTable table-id="table-pasien" title="Kegiatan Pelayanan Kesehatan Jiwa" :filter-configs="filterConfigs"
            :table-options="tableOptions" :show-filter="true" />
    </div>
</template>

<script>
import DataTable from '@/components/global/DataTable.vue'

export default {
    components: {
        DataTable
    },
    data() {
        return {
            filterConfigs: [
                {
                    id: 'start_date',
                    label: 'Tanggal Awal',
                    field: 'start_date',
                    type: 'date',
                    colClass: 'col-sm-3',
                    component: ''
                },
                {
                    id: 'end_date',
                    label: 'Tanggal Akhir',
                    field: 'end_date',
                    type: 'date',
                    colClass: 'col-sm-3',
                    component: ''
                },
            ],
            tableOptions: {
                baseUrl: '/api/rekapitulasi-pelayanan/kegiatan-pelayanan-kesehatan-jiwa',
                layout: 'fitDataStretch',
                responsiveLayout: 'collapse',
                columns: [
                    {
                        title: "No.",
                        field: "no",
                        hozAlign: "center",

                    },
                    {
                        title: "Jenis Kegiatan",
                        field: "jenis",
                    },
                    {
                        title: "Laki - laki",
                        field: "total",
                        hozAlign: "center",
                    },
                    {
                        title: "Perempuan",
                        field: "total",
                        hozAlign: "center",
                    },
                    {
                        title: "Jumlah",
                        field: "total",
                        hozAlign: "center",
                    }
                ],
                ajaxResponse: (url, params, response) => response
            }
        }
    },
}
</script>
